import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import ActivationPage from 'gatsby-theme-carbon/src/templates/ActivationPage';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h3>{`RedHat Interactive Learning`}</h3>
    <p>{`To help understand OpenShift in more detail work through these `}<strong parentName="p">{`KataKoda`}</strong>{` self paced learning modules offered by RedHat`}</p>
    <ActivationPage content="openshift" tileColor="bx--article-card--redhat" mdxType="ActivationPage">
    </ActivationPage>
    <h3>{`OpenShift Development`}</h3>
    <p>{`The following topics help you understand the foundation of OpenShift development principles.`}</p>
    <ActivationPage content="openshift_dev" tileColor="bx--article-card--redhat" mdxType="ActivationPage">
    </ActivationPage>
    <h3>{`OpenShift Advanced`}</h3>
    <p>{`The following topics are advanced and should be used when you have solid understanding of how to
develop applications for the Red Hat OpenShift platform.`}</p>
    <ActivationPage content="openshift_adv" tileColor="bx--article-card--redhat" mdxType="ActivationPage">
    </ActivationPage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      